import React from 'react';

export const RightFriendsLine = () => {
    return (
        <svg width="177" height="90" viewBox="0 0 177 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.17" d="M162 15V15C162 48.1371 135.137 75 102 75H15" stroke="url(#paint0_linear_10_216)"
                  stroke-width="30" stroke-linecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_10_216" x1="165.669" y1="8.5" x2="7.79862" y2="27.6505"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#B282E5" stop-opacity="0.7"/>
                    <stop offset="1" stop-color="#B282E5" stop-opacity="0.3"/>
                </linearGradient>
            </defs>
        </svg>

    )
}